import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { columnas } from "./columnas";
import { InicioCargaDescargaEdit } from "./nuevacarga";
import { ReporteManifiestoEdit, ReporteCajaDatos } from "./reportemanifiesto";

type Entity = models.CajaRutaDTO;
export interface Props {
    value: Entity[];
}

/**
* Listado de CajaRutaDTO
*/
class CajaRutaDTOListNoRx extends React.PureComponent<Props> {
    private modals = kea.createModalManager();

    onInicio = async (caja: Entity, tipo: models.TipoCargaDescarga) => {
        if (caja.UltimoStatus.IdCamionAsignado == null) throw new Error("La caja no tiene camión asignado");

        const camion = await resources.Camion.get(caja.UltimoStatus.IdCamionAsignado);
        const idChofer = camion.IdUltimoChoferRuta;

        const inicioCarga: models.InicioCargaDescarga = {
            IdChofer: idChofer!,
            IdCajaRuta: caja.IdRegistro,
            Tipo: tipo
        };

        const result = await this.modals.showModal(InicioCargaDescargaEdit, undefined, inicioCarga);
        if (result.result) {
            const id = await resources.CargaDescarga.IniciarCargaDescarga(result.value);
            history.go(`./${id}`);
        }
    }

    onCargar = async (x: Entity) => {
        await this.onInicio(x, models.TipoCargaDescarga.Carga);
    }
    onDescargar = async (x: Entity) => {
        await this.onInicio(x, models.TipoCargaDescarga.Descarga);
    }

    onVerCargaDescarga = async (x: Entity) => {
        history.go(`./${x.IdCargaDescarga}/`);
    }

    onReporteManifiesto = async (x: Entity) => {
        const value: ReporteCajaDatos = {
            idCaja: x.IdRegistro,
            fecha: new Date()
        };
        const result = await this.modals.showModal(ReporteManifiestoEdit, undefined, value);
        if (result.result) {
            const params = result.value;
            const datos = await resources.CajaRuta.ReporteDeManifiesto(params.idCaja, params.fecha);
            kea.printPdf(datos);
        }
    }

    render() {
        const cols = columnas(this);
        return (
            <div>
                <kea.Grid2 items={this.props.value} columnas={cols} />
                {this.modals.component}
            </div>
        );
    }
}
export const CajaRutaDTOList = kea.defaultProps(kea.mapProps(componentToRx(CajaRutaDTOListNoRx), x => ({ ...x, value: x.value || [] })),
    {
        value: observeResource(resources.CajaRuta.queryNoMemo)
    });


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cargacajaruta/list/cajas/list.tsx